import { Box, Typography, Avatar } from "@mui/material"
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded"

const SelectedCard = ({ doctorData }) => {
  if (!doctorData) return null

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        p: 3,
        width: "100%",
        backgroundColor: "SHADES_100",
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: "flex", gap: 2 }}>
        <Avatar
          sx={{ width: { xs: 60, sm: 120 }, height: { xs: 60, sm: 120 } }}
          alt="doctor-avatar"
          src={doctorData.avatarImage}
        />
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1, gap: 1 }}>
          {doctorData.subjects && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {doctorData.subjects.map(subject => (
                <Typography
                  component="div"
                  variant="headingSmallHeavy"
                  sx={{ color: "PRIMARY_700" }}
                  key={subject.id}
                >
                  {subject.name}
                </Typography>
              ))}
            </Box>
          )}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography component="div" variant="headingH6Heavy">
              {doctorData.name}
            </Typography>
            {doctorData.approvedAt && <CheckCircleRoundedIcon color={"primary"} />}
          </Box>

          {doctorData.educations.length > 0 && (
            <>
              <Typography
                component="div"
                variant="headingMediumRegular"
                sx={{ color: "SHADES_600" }}
              >
                學歷
              </Typography>
              <Box
                component="ul"
                sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 0, mb: 1 }}
              >
                {doctorData.educations.map((education, index) => {
                  return (
                    <Typography key={index} component="li" sx={{ color: "SHADES_800" }}>
                      {education}
                    </Typography>
                  )
                })}
              </Box>
            </>
          )}
          {doctorData.experiences.length > 0 && (
            <>
              <Typography
                component="div"
                variant="headingMediumRegular"
                sx={{ color: "SHADES_600" }}
              >
                經歷
              </Typography>
              <Box
                component="ul"
                sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 0, mb: 1 }}
              >
                {doctorData.experiences.map((experience, index) => {
                  return (
                    <Typography key={index} component="li" sx={{ color: "SHADES_800" }}>
                      {experience}
                    </Typography>
                  )
                })}
              </Box>
            </>
          )}
          {doctorData.clinics.length > 0 && (
            <>
              <Typography
                component="div"
                variant="headingMediumRegular"
                sx={{ color: "SHADES_600" }}
              >
                執業診所
              </Typography>

              {doctorData.clinics.map(clinic => {
                return (
                  <Box
                    key={clinic.id}
                    sx={{
                      mb: 1,
                      backgroundColor: "SHADES_000",
                      py: 1,
                      px: { xs: 1, sm: 2 },
                      border: 1,
                      borderColor: "SHADES_200",
                      borderRadius: 1,
                    }}
                  >
                    <Typography component="div" sx={{ color: "SHADES_500" }}>
                      {clinic.name || clinic.googlePlace?.name}
                    </Typography>
                    {clinic.googlePlace && (
                      <>
                        <Typography component="div" sx={{ color: "SHADES_500" }}>
                          {clinic.googlePlace.formattedAddress}
                        </Typography>
                      </>
                    )}
                  </Box>
                )
              })}
            </>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default SelectedCard
